const ComponentsTheme = {
  navbar: {
    bg: {
      light: 'blue.900',
      dark: 'blackAlpha.900',
    }
  },
  navbarSub: {
    bg: {
      light: 'blue.800',
      dark: 'blackAlpha.800',
    },
    color: {
      light: 'white',
      dark: 'white',
    }
  },
  footer: {
    bg: {
      light: 'gray.100',
      dark: 'blackAlpha.500',
    }
  },
  link: {
    color: {
      light: 'orange.500',
      dark: 'cyan',
    }
  },
  chart: {
    bg: {
      light: '#fff',
      dark: '#0d2221',
    },
    gridColor: {
      light: '#ddd',
      dark: '#333',
    }
  },
  panel: {
    heading: {
      bg: {
        light: 'teal.100',
        dark: 'blackAlpha.400',
      }
    }
  }
}

export default ComponentsTheme
